// extracted by mini-css-extract-plugin
export default {"FAQ_section":"YourFaqs_FAQ_section__fnXMd","addLink":"YourFaqs_addLink__fujdI","conversationText":"YourFaqs_conversationText__LbCs1","inputTextare":"YourFaqs_inputTextare__T8uJE"};